
import React from "react";

interface SpecialFormatsHeaderProps {
  title: string;
  subtitle: string;
  description: string;
}

const SpecialFormatsHeader: React.FC<SpecialFormatsHeaderProps> = ({
  title,
  subtitle,
  description,
}) => {
  return (
    <div className="text-left md:text-center max-w-3xl mx-auto mb-16">
      <div className="text-center">
        <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
          {subtitle}
        </span>
      </div>
      <h2 className="text-joerg-800 mb-6 animate-fade-in">{title}</h2>
      <p className="mt-4 text-joerg-600 text-lg leading-relaxed max-w-[70ch] mx-auto animate-fade-in">
        {description}
      </p>
    </div>
  );
};

export default SpecialFormatsHeader;
